import { Epic } from 'redux-observable';
import { mergeMap, filter } from 'rxjs/operators';
import { RootState } from '../store';
import { fetchRegionMap } from '../../services/api';
import {
  fetchRegionMapStart,
  fetchRegionMapSuccess,
  fetchRegionMapFailure
} from '../slices/regionMapSlice';

export const fetchRegionMapEpic: Epic<any, any, RootState> = (action$) =>
  action$.pipe(
    filter((action) => action.type === fetchRegionMapStart.type),
    mergeMap((action) =>
      fetchRegionMap(action.payload).then(
        (data) => fetchRegionMapSuccess(data),
        (error) => fetchRegionMapFailure(error.message)
      )
    )
  );

export const regionMapEpics = [fetchRegionMapEpic]; 